import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Component, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import {ViewChild} from "@angular/core";

import * as lodash from "lodash";

@Component({
  selector: 'autocomplete-fixed-data',
  templateUrl: './autocomplete-fixed.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteFixedDataComponent),
      multi: true
    }
  ]
})
export class AutocompleteFixedDataComponent implements ControlValueAccessor {

  @Input('value') _value: any;
  @Input() baseData: Array<any>;

  @ViewChild('autocomplete')
  autocomplete: any;

  filteredData: Array<any>;

  @Output() onFiltering: EventEmitter<any>;

  constructor() {

  }

  ngAfterContentInit() {
    this.filteredData = this.baseData;
  }

  focusin() {
    setTimeout(() => this.autocomplete.open = true, 550);
  }

  requestData(filter: string) {
    this.filteredData = this.baseData.filter(obj => {
      filter = lodash.deburr(filter);
      filter = lodash.lowerCase(filter);

      let comp = obj.libelle;
      comp = lodash.deburr(comp);
      comp = lodash.lowerCase(comp);

      return comp.indexOf(filter) >= 0;
    })
  }

  //Controle value accessor
  onChange: any = () => {
  };
  onTouched: any = () => {
  };

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  writeValue(value: any) {
    this.value = value;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/autocomplete-fixed/autocomplete-fixed.component.ts